import './academyhosp/style';
import FormStructure from './academyhosp/form_structure';

export default FormStructure;